<template>
  <v-card class="ma-5">
    <v-row
      class="flex-column flex-lg-row flex-xl-row"
      no-gutters
    >
      <v-col :cols="isMobile() ? 12 : item.img.url ? 6 : 3">
        <v-img
          v-if="item.img.url"
          :src="item.img.url"
          :alt="item.img.alt"
          aspect-ratio="1.33"
          position="center center"
          contain
        />
        <v-img
          v-if="item.imgVertical.url"
          :src="item.imgVertical.url"
          :alt="item.imgVertical.alt"
          aspect-ratio="0.8"
          max-height="500px"
          position="center center"
          contain
        />
      </v-col>
      <v-col :cols="isMobile() ? 12 :item.img.url ? 6 : 9">
        <v-card-title class="title primary--text">
          <router-link
            v-if="withLink"
            class="link"
            :to="`/naujienos/${item.uid}`"
          >
            {{ item.title }}
          </router-link>
          <span v-else>{{ item.title }}</span>
        </v-card-title>
        <v-card-text class="md-px-5 xs-px-1 py-2">
          <prismic-rich-text
            v-if="item.body"
            :field="item.body"
          />
        </v-card-text>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
export default {
  name: "AppHeader",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    withLink: Boolean
  },
  methods: {
    isMobile() {
      return !this.$vuetify.breakpoint.mdAndUp;
    }
  }
};
</script>
<style scoped>
.title {
  word-break: keep-all;
}
.link {
  text-decoration: none;
}
.link:hover {
  text-decoration: underline;
}
</style>
